import { useAppMutation } from "../../../http/useAppMutation.ts";

export const useUpdateComposition = (invalidateQueries: string[] = []) => {
  const { mutate: updateCompositionData, isLoading } = useAppMutation({
    path: "compositions/update",
    invalidate: invalidateQueries,
    waitForInvalidation: false,
  }).mutation;

  return {
    updateComposition: ({
      uuid,
      fabricCanvasData,
      thumbnailImageUuid,
    }: {
      uuid: string;
      fabricCanvasData?: any;
      thumbnailImageUuid?: string | undefined;
    }) => {
      updateCompositionData({
        uuid,
        fabric_canvas_data: fabricCanvasData,
        thumbnail_image_uuid: thumbnailImageUuid,
      });
    },
    isUpdateCompositionLoading: isLoading,
  };
};
